<template>
  <div>
    <Input placeholder="单位名称" style="width: 300px; margin-bottom: 12px;" clearable @on-change="handleInputChange"></Input>
    <Table
      ref="dataTable"
      border
      :columns="renderColumn"
      :data="renderList"
    >
      <template slot="action" slot-scope="{ row }">
        <Button type="info" @click="handleSelectSchool(row)">切换单位</Button>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      renderColumn: [
        {
          title: '单位名称',
          key: 'schoolName',
          minWidth: 200,
          align: 'center'
        }, {
          title: '区域',
          key: 'areaName',
          minWidth: 200,
          align: 'center'
        }, {
          title: '操作',
          slot: 'action',
          minWidth: 120,
          align: 'center'
        }
      ],
      renderList: []
    };
  },
  watch: {
    list(newVal, oldVal) {
      this.renderList = newVal;
    }
  },
  methods: {
    handleSelectSchool(schoolItem) {
      this.$emit('change', schoolItem);
    },
    handleInputChange(event) {
      this.renderList = this.list.filter(item => item.schoolName.includes(event.target.value));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
